import React from 'react';
import PropTypes from 'prop-types';
import HitCard from './HitCard';

const LocationHit = ({ hit }) => {
  return (
    <div key={hit.model_id}>
      <HitCard hit={hit} />
    </div>
  );
};

LocationHit.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  hit: PropTypes.object.isRequired
};

LocationHit.defaultProps = {};

export default LocationHit;
